import React from "react";

const VerifyHost = () => {
  return (
    <>
      <h1>verifyElectionHost</h1>
    </>
  );
};

export default VerifyHost;
